/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from "@fluentui/react-utilities";

import { InputSectionSlots, InputSectionState } from "./InputSection.types";

export function renderInputSection_unstable(state: InputSectionState) {
  assertSlots<InputSectionSlots>(state);
  return (
    <state.root>
      <state.legend />
      {state.description && <state.description />}
      {state.root.children}
    </state.root>
  )
}
